import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

interface PageLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}

const PageLayout = ({ children, title, subtitle }: PageLayoutProps) => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="pt-20 md:pt-24 pb-10 md:pb-16 gradient-hero relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,hsl(var(--primary)/0.3),transparent_70%)]" />
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-primary-foreground mb-3 md:mb-4">
            {title}
          </h1>
          {subtitle && (
            <p className="text-primary-foreground/80 max-w-2xl mx-auto text-sm md:text-lg">
              {subtitle}
            </p>
          )}
        </div>
      </section>
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default PageLayout;
